import { React } from "react";
import PropTypes from "prop-types";
import CourseLandingPageHeading from "./CourseLandingPageHeading";
import CourseLandingPageDescription from "./CourseLandingPageDescription";
import CourseLandingPageDetails from "./CourseLandingPageDetails";
import CourseLandingPageVideoPromo from "./CourseLandingPageVideoPromo";

export default function CourseLandingPageSectionHeader({ data }) {
  const { title, subtitle, courseDescription, applyByDate, datesDisplay, dayTimeDisplay, media } = data;

  return (
    <div className="CourseLandingPageSection-header container">
      <CourseLandingPageHeading title={title} subtitle={subtitle} />
      <CourseLandingPageDescription courseDescription={courseDescription} />
      <CourseLandingPageDetails  
        title={title}
        applyByDate={applyByDate}
        datesDisplay={datesDisplay}
        dayTimeDisplay={dayTimeDisplay}
        courseImageURL={media.courseImageURL}
      />
      <CourseLandingPageVideoPromo videoPromo={media.videoPromo} />
    </div>
  )
}

CourseLandingPageSectionHeader.propTypes = {
    data: PropTypes.object
}